/** Project hub routes — scope, schedule, and consolidated budget governance (PM). */
export const PROJECT_BUDGET_ROUTES = [
  '/master-budget',
  '/budgets/management',
];

export const PROJECT_CHILD_ROUTES = [
  '/projects/portfolio',
  '/projects/dashboard',
  '/projects/scope',
  '/projects/tender',
  '/projects/schedule',
  '/projects/combined-progress',
  ...PROJECT_BUDGET_ROUTES,
];

export function hasProjectTenderNavAccess(hasMenuAccess, { activeProject } = {}) {
  if (!activeProject) return false;
  return hasMenuAccess('/projects/tender');
}

export function hasProjectBudgetNavAccess(hasMenuAccess, { activeProject, hasApprovedBudget } = {}) {
  if (!activeProject) return false;
  return (
    (hasApprovedBudget && hasMenuAccess('/master-budget'))
    || hasMenuAccess('/budgets/management')
  );
}
